import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  text-align: center;
  padding: 4px 10px;
  color: #445;
  font-weight: 300;
`;

export const Image = styled.div`
  flex: 1;
  background-image: url(/x-wing.jpg);
  background-size: contain;
  background-repeat: no-repeat;
`;
